import clsx from 'clsx'
import type {UILayout} from 'swayok-react-mdb-ui-kit/types/Common'
import {FirstAdBonusPromoCard} from '../../../../layout/promo_cards/FirstAdBonusPromoCard'
import {GetAdvancePromoCard} from '../../../../layout/promo_cards/GetAdvancePromoCard'
import {PromoteYourAdsPromoCard} from '../../../../layout/promo_cards/PromoteYourAdsPromoCard'

interface AdsListPromoBannerProps {
    listUid: string
    sideMenuVisibleFromBsBreakpoint?: UILayout['bootstrapSize']
}

// Промо-баннеры для списка объявлений.
export function AdsListPromoBanners(props: AdsListPromoBannerProps) {
    const {
        listUid,
        sideMenuVisibleFromBsBreakpoint = 'md',
    } = props

    const utmSource = listUid + '_items_list'

    // Боковая панель видна только на экранах начиная с sideMenuVisibleFromBsBreakpoint.
    // В боковой панели показываются баннеры FirstAdBonusPromoCard и PromoteYourAdsPromoCard.
    // В этом случае нужно показать только баннер GetAdvancePromoCard на 5-й строке.
    return (
        <>
            <GetAdvancePromoCard
                className={clsx(
                    'inside-items-list d-none',
                    'd-' + sideMenuVisibleFromBsBreakpoint + '-flex'
                )}
                utmSource={utmSource}
                gridOrder={31}
            />
            <FirstAdBonusPromoCard
                className={clsx(
                    'inside-items-list',
                    'd-' + sideMenuVisibleFromBsBreakpoint + '-none'
                )}
                utmSource={utmSource}
                gridOrder={31}
            />
            <PromoteYourAdsPromoCard
                className={clsx(
                    'inside-items-list',
                    'd-' + sideMenuVisibleFromBsBreakpoint + '-none'
                )}
                utmSource={utmSource}
                gridOrder={61}
            />
            <GetAdvancePromoCard
                className={clsx(
                    'inside-items-list',
                    'd-' + sideMenuVisibleFromBsBreakpoint + '-none'
                )}
                utmSource={utmSource}
                gridOrder={91}
            />
        </>
    )
}
